/**
 * Game view.
 *
 * @module app/components/crossSell/games/GameView
 */
import _ from 'lodash';
import jQuery from 'jquery';
import MessageBusTopics from '../../../../common/MessageBusTopics';
import template from '../../../views/templates/games/GameOverlay';
import DeviceDetector from '../../DeviceDetector';

/**
 * Create a GameView instance.
 * @constructor
 * @public
 * returns {void}
 */
var GameView = function GameView(messageBus, gameUrl) {

    this.created = false;
    this.messageBus = messageBus;
    this.gameUrl = gameUrl;
    this.element = null;
    

    this.create();
};

GameView.prototype = {

    /**
     * HTML template.
     * @type {Function}
     */
    template: _.template(template),

    /**
     * Initialise this view.
     * @returns {void}
     * @private
     */
    create: function create() {
        if (this.created) {
            return;
        }

        this.element = jQuery(this.template({
            url: this.gameUrl,
        }));
        
        jQuery('body').append(this.element);

        if (DeviceDetector.isMobile()) {

            window.addEventListener('message', this.listenToPostMessages.bind(this));
            window.addEventListener('resize', this.sendPostMessages.bind(this));
        }

        this.bind();
        this.show();
    },

    /**
     * Create the postMessages to send in event listeners
     * @private
     * @returns {void}
     */
    sendPostMessages: function sendPostMessages() {
        var iframeReference = jQuery('.game-iframe')[0];

        iframeReference && iframeReference.contentWindow.postMessage(
            {
                type: 'resize',
                width: jQuery(window).width(),
                height: jQuery(window).height(),
            },
            '*'
        );
    },

    /**
     * Create the listeners for handling postMessages
     * @private
     * @returns {void}
     */
    listenToPostMessages: function listenToPostMessages(event) {
        if (event.data.type === 'requestSize') {
            this.sendPostMessages();
        }
    },

    /**
     * Bind to controls.
     * @private
     * @returns {void}
     */
    bind: function bind() {

        var self = this;

        this.element.find('.game-minimize').on('click', function () {

            self.messageBus.publish(MessageBusTopics.GAME_MINIMIZE);
        });
    },

    /**
     * Show this view.
     * @returns {void}
     * @private
     */
    show: function show() {

        this.element.show();
        this.messageBus.publish(MessageBusTopics.GAME_SHOWN);
    },

    /**
     * Hide this view.
     * @returns {void}
     * @private
     */
    hide: function hide() {

        this.element.hide();
        this.messageBus.publish(MessageBusTopics.GAME_HIDDEN);
    },

    /**
     * Destroy this view.
     * @returns {void}
     * @private
     */
    destroy: function destroy() {
        this.element.remove();
        this.element = null;
        this.messageBus.publish(MessageBusTopics.GAME_DESTROY);

        if (DeviceDetector.isMobile() && this.iframeReference) {
            window.removeEventListener('message', this.listenToPostMessages);
            window.removeEventListener('resize', this.sendPostMessages);
        }
    },
};

export default GameView;
